export default "__VITE_ASSET__ChDLedBc__"